import { render, staticRenderFns } from "./PromotionInputTypeField.vue?vue&type=template&id=df3e9a84"
import script from "./PromotionInputTypeField.vue?vue&type=script&lang=js"
export * from "./PromotionInputTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports